import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { wildCardSearch } from 'actions/wildCard';
import TaxonomyBrandPage from 'containers/TaxonomyBrandPage';
import Landing from 'containers/Landing';
import { Loader } from 'components/Loader';

export class WildCard extends Component {
  static fetchDataOnServer(store, location) {
    // zfc diamond api is based on the current uri.
    return store.dispatch(wildCardSearch({ pathname: location.pathname }));
  }

  componentDidMount() {
    const { router: { location: { pathname } }, uri: lastUri, wildCardSearch } = this.props;
    // need to populate uri in state and trick wildcard container into not refetching when its first mounted from ssr.
    if (pathname !== lastUri) {
      wildCardSearch({ pathname });
    }
  }

  render() {
    const { location, routeDetails = {}, route = {} } = this.props;
    const { SearchComponent } = route;
    const commonProps = { location };
    const { type, brand_id: brandId, page_name: pageName } = routeDetails;

    const paramPageName = { pageName };
    const paramBrandId = { brandId };
    const paramSeoName = { seoName: location.pathname };

    switch (type) {
      case 'landing':
        return <Landing {...commonProps} params={paramPageName} />;
      case 'brand':
        return <TaxonomyBrandPage {...commonProps} params={paramBrandId} />;
      case 'zso':
        return <SearchComponent {...commonProps} params={paramSeoName} route={route} />;
      case 'search':
        return <SearchComponent {...commonProps} params={paramSeoName} route={route} />;
      default:
        return <Loader />;
    }
  }
}

WildCard.contextTypes = {
  testId: PropTypes.func
};

function mapStateToProps(state) {
  const { wildCard: { uri, routeDetails } } = state;
  return {
    routeDetails,
    uri
  };
}

export default connect(mapStateToProps, { wildCardSearch })(WildCard);
